import { required } from '@/utils/validations';

const validate = values => {
	const errors = {};
	errors.description = required(values.description, 'Description');

	return errors;
};

export default validate;
